import React, { useEffect, useState } from 'react';

import { User } from '@qality/common-model';
import { StorageOfUniqueServices, UserService } from '@qality/common-service';

type Props = {
  children: React.ReactChild;
};

export const TestCycleDetailsPageContext = React.createContext<{
  currentUser: User;
}>({ currentUser: null });

export function TestCycleDetailsPageContextProvider({ children }: Props) {
  const [currentUser, setCurrentUser] = useState<User>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const newCurrentUser = await UserService.getCurrentUser();
        setCurrentUser(newCurrentUser);
      } catch (e) {
        StorageOfUniqueServices.get('ErrorHandlingUtils').handleCriticalError(
          e,
          'Error ocurred during retrieving user data.',
          plugin.servicedeskUrl
        );
      }
    };

    fetchData();
  }, []);

  return (
    <TestCycleDetailsPageContext.Provider
      value={{
        currentUser,
      }}
    >
      {children}
    </TestCycleDetailsPageContext.Provider>
  );
}
